// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__kWmz2","itemTitle":"ClientEmergencyInfo_itemTitle__3froY","itemText":"ClientEmergencyInfo_itemText__2EGmg"};